import styled from 'styled-components';
import media from '@/styles/media';
import { Anchor } from './anchor-text';

export const AnchorReset = styled(Anchor)`
  margin: 20px 0;
`;

export const Logo = styled.img`
  width: 145px;
  height: 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('/assets/images/auth/login-main-bg.svg');
  background-color: white;
  ${media.lg`
    background-image: none;
    background-color: #f8f9ff;
  `}
`;

export const LayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 50px;
  box-sizing: border-box;
  `;

export const MainDiv = styled.div`
  display: flex;
  width: 100%;
  max-width: 1400px;
  height: 100%;
  max-height: 819px;
  margin: auto 0px;
  border-radius: 50px;
  background-color: white;
  opacity: 0.9;
  margin: 0 10px;
  ${media.lg`
    background-color: #f8f9ff;
  `}
`;

export const UpperDiv = styled.div`
  display: flex;
  padding: 50px 80px;
  justify-content: space-between;
  ${media.lg`
    display: none;
  `}
`;

export const HeaderButtonDiv = styled.div`
  display: flex;
  align-items: center;
`;
